import React from 'react';
import type { Candidate } from '@axiom/validation';
import { Banner, Gutter, Layout, LayoutItem, Paragraph } from '@axiom/ui';

import { PreferredWeeklyHoursUtil } from '../../utils/preferred-weekly-hours-util';

export type PreferredWeeklyHoursStatusMessageProps = {
  name?: string;
  candidate: Candidate;
};

export const PreferredWeeklyHoursStatusMessage = ({
  name = 'PREFERRED_WEEKLY_HOURS_STATUS_MESSAGE',
  candidate,
}: PreferredWeeklyHoursStatusMessageProps) => {
  const normalizedProfileStatus = candidate.profileStatus ?? 'unknown';
  const statusSentence = PreferredWeeklyHoursUtil.getStatusMessage({
    candidate,
  });

  return (
    <div data-test={name}>
      {statusSentence ? (
        <Gutter bottom="16px">
          <Banner>
            <Layout
              direction="horizontal"
              position="left middle"
              name={`PENDO-AVAILABILITY_STATUS-${normalizedProfileStatus.toUpperCase()}`}
            >
              <LayoutItem>
                <Paragraph name="STATUS_SENTENCE">{statusSentence}</Paragraph>
              </LayoutItem>
            </Layout>
          </Banner>
        </Gutter>
      ) : null}
    </div>
  );
};
